import React, { act, useEffect, useState } from "react";
import { useAuth } from "../../../auth/FirebaseAuth.js";

import {
  createDoc,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getLocalStringFromFlutter,
  getRefFromId,
  queryCollection,
} from "../../../models/DataFunctions.js";
import SecondaryButton from "../../../buttons/SecondaryButton.js";

import { useAppContext } from "../../../config/AppContext.js";

import { useSnackbar } from "notistack";

import TextField2T from "../../../textfields/TextField2T.js";
import PrimaryButton from "../../../buttons/PrimaryButton.js";

import SmallSpinner from "../../../loading/SmallSpinner.js";
import NavBarButton from "../../../buttons/NavBarButton.js";
import { BlockNumer } from "../../home/MasterSmallStats.js";
import Icon1 from "../../../icons/Icon.js";
import TextFieldEmail from "../../../textfields/TextFieldEmail.js";
import DataGridGPT2 from "../../../tables/DataGridGPT2.js";
import { dbHexamails } from "../../../config/FirebaseConfig.js";
import { getDoc, updateDoc } from "firebase/firestore";
import Modal1 from "../../../modals/Modal1.js";
import { email_base, email_base_trigger } from "./hexamails_data.js";
import TabGPT from "../../../tabs/TabGPT.js";
import {
  BlockCampaign,
  BlockEmailTemplate,
  deleteDocHM,
  getDocHm,
  PrimaryButtonHexamails,
  updateDocHM,
} from "./Hexamails.js";
import WarningButton from "../../../buttons/WarningButton.js";
import { trigger } from "devextreme-react/cjs/common/core/events.js";
import { ToggleSettingsBrick } from "../../../textfields/EasySwitch.js";

export function EmailTemplatePage({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [tab, setTab] = useState("kpis");
  const [email_selected, setEmailSelected] = useState(null);
  const [campaign_selected, setCampaignSelected] = useState(null);
  const [active_campaign_selected, setActiveCampaignSelected] = useState(null);
  const [choose_email_for_campaign, setChooseEmailForCampaigns] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [email_templates, setEmailTempaltes] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [active_campaigns, setActiveCampaigns] = useState([]);
  const [choose_user_open, setChooseUserOpen] = useState(false);
  const [masters, setMasters] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [tab_campaign, setTabCampaign] = useState("campaign");

  const handleFetchData = async () => {
    let email_templates = await queryCollection(
      "email_template",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    let campagins = await queryCollection(
      "campaign",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    let active_campagins = await queryCollection(
      "active_campaign",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    setEmailTempaltes(email_templates);
    setActiveCampaigns(active_campagins);
    setCampaigns(campagins);
  };

  const createDocHM = async (collection, data) => {
    let res = await createDoc(collection, data, dbHexamails);
    return res;
  };

  const handleDeleteEmailTemplate = async () => {
    if (!email_selected) {
      return;
    }
    await deleteDocHM("email_template", email_selected.id);
    setEmailSelected(null);
    handleFetchData();
    handleClickVariant("Template supprimé", "success");
  };

  const [loadingData, setLoadingData] = useState(false);

  const handleCreateNewTemplate = async (trigger = false) => {
    setLoadingData(true);
    let new_doc = await createDocHM("email_template", {
      object: "Nouveau template",
      body: "Bonjour {{prenom}}",
      key: "no_key",
      creation_date: getFlutterTime(),
      trigger: trigger,
    });
    setEmailSelected(new_doc);
    setLoadingData(false);
    handleFetchData();
  };

  const handleDuplicateTemplate = async () => {
    if (!email_selected) {
      return;
    }
    setLoadingData(true);
    let new_body = {
      ...email_selected,
      object: email_selected.object + " (copie)",
      creation_date: getFlutterTime(),
    };
    delete new_body.id;
    delete new_body.ref;
    let new_doc = await createDocHM("email_template", new_body);
    new_doc = await getDocHm("email_template", new_doc.id);
    setEmailSelected(new_doc);
    setLoadingData(false);
    handleFetchData();
    handleClickVariant("Template dupliqué", "success");
  };

  const handleSaveEmailTemplate = async () => {
    if (!email_selected.id) {
      return;
    }
    setLoadingData(true);
    let new_email = {
      ...email_selected,
      last_update: getFlutterTime(),
    };
    await updateDocHM("email_template", new_email.id, new_email);
    setLoadingData(false);
    handleFetchData();
    handleClickVariant("Template sauvegardé", "success");
  };

  const handleGenerateBody = async () => {
    setLoadingData(true);
    let generated_body = generateDynamicEmailTemplateHtmlFromBaseHtml({
      header_text: email_selected.header_text,
      body_title: email_selected.body_title,
      body_content_1: email_selected.body_content_1,
      body_content_2: email_selected.body_content_2,
      web_button_label: email_selected.web_button_label,
      mobile_button_label: email_selected.mobile_button_label,
      web_button_url: email_selected.web_button_url,
      mobile_button_url: email_selected.mobile_button_url,
      support_url: email_selected.support_url,
      image_url: email_selected.image_url,

      gif_url: email_selected.gif_url,
      trigger: email_selected.trigger,
    });
    setEmailSelected({ ...email_selected, body: generated_body });
    setLoadingData(false);
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    setCampaignSelected(null);

    handleFetchData();
  }, [tab]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser) {
    return <SmallSpinner></SmallSpinner>;
  }

  // Render the client data
  return (
    <>
      <div className="flex flex-col gap-1 mt-4 w-full min-w-c500">
        {email_selected ? (
          <div className="flex flex-col  w-full  ">
            <div className="flex flex-row gap-2 items-center mb-4">
              <PrimaryButtonHexamails
                onClick={() => handleDuplicateTemplate()}
                startIcon={
                  <Icon1 icon_name="copy" width="18px" fill="white"></Icon1>
                }
              >
                Dupliquer template{" "}
                {loadingData && <SmallSpinner></SmallSpinner>}
              </PrimaryButtonHexamails>{" "}
              <PrimaryButtonHexamails onClick={() => setEmailSelected(null)}>
                Fermer
              </PrimaryButtonHexamails>
              {email_selected.id}
              <ToggleSettingsBrick
                title={"Trigger"}
                checked={email_selected.trigger}
                onChange={(checked) =>
                  setEmailSelected({ ...email_selected, trigger: checked })
                }
              ></ToggleSettingsBrick>
            </div>
            <div className="flex flex-row  w-full   rounded-lg ">
              <div className="flex flex-col w-c700  border-1 rounded-lg ">
                <div className="text-h3 font-bold px-2 pb-2 border-b-1">
                  <TextField2T
                    noborder={true}
                    value={email_selected.object}
                    onChange={(e) =>
                      setEmailSelected({
                        ...email_selected,
                        object: e.target.value,
                      })
                    }
                  ></TextField2T>
                </div>
                <div className="text-h4 text-shadow_50  px-2 pb-2 border-b-1">
                  <TextField2T
                    noborder={true}
                    value={email_selected.event}
                    onChange={(e) =>
                      setEmailSelected({
                        ...email_selected,
                        event: e.target.value,
                      })
                    }
                    className="text-h4 text-indigo-500"
                  ></TextField2T>
                </div>
                <TextFieldEmail
                  noborder={true}
                  className="h-full max-h-full text-h5 p-3 bg-transparent  rounded-3xl"
                  placeholder={"header_text"}
                  value={email_selected.header_text}
                  rows={2}
                  onChange={(e) =>
                    setEmailSelected({
                      ...email_selected,
                      header_text: e.target.value,
                    })
                  }
                ></TextFieldEmail>
                {!email_selected.trigger && (
                  <>
                    <TextFieldEmail
                      noborder={true}
                      className="h-full max-h-full text-h5 p-3 bg-transparent  rounded-3xl"
                      placeholder={"body_title"}
                      value={email_selected.body_title}
                      rows={2}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          body_title: e.target.value,
                        })
                      }
                    ></TextFieldEmail>
                    <TextFieldEmail
                      noborder={true}
                      className="h-full max-h-full text-h5 p-3 bg-transparent  rounded-3xl"
                      placeholder="body_content_1"
                      value={email_selected.body_content_1}
                      rows={2}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          body_content_1: e.target.value,
                        })
                      }
                    ></TextFieldEmail>
                    <TextFieldEmail
                      noborder={true}
                      className="h-full max-h-full text-h5 p-3 bg-transparent  rounded-3xl"
                      placeholder={"body_content_2"}
                      value={email_selected.body_content_2}
                      rows={2}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          body_content_2: e.target.value,
                        })
                      }
                    ></TextFieldEmail>
                    <TextField2T
                      noborder={true}
                      label={"web_button_label"}
                      value={email_selected.web_button_label}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          web_button_label: e.target.value,
                        })
                      }
                      className="text-h4 "
                    ></TextField2T>
                    <TextField2T
                      noborder={true}
                      label={"mobile_button_label"}
                      value={email_selected.mobile_button_label}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          mobile_button_label: e.target.value,
                        })
                      }
                      className="text-h4 "
                    ></TextField2T>
                    <TextField2T
                      noborder={true}
                      label={"web_button_url"}
                      value={email_selected.web_button_url}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          web_button_url: e.target.value,
                        })
                      }
                      className="text-h4 "
                    ></TextField2T>
                    <TextField2T
                      noborder={true}
                      label={"mobile_button_url"}
                      value={email_selected.mobile_button_url}
                      onChange={(e) =>
                        setEmailSelected({
                          ...email_selected,
                          mobile_button_url: e.target.value,
                        })
                      }
                      className="text-h4 "
                    ></TextField2T>
                  </>
                )}
                <TextField2T
                  noborder={true}
                  label={"image_url"}
                  value={email_selected.image_url}
                  onChange={(e) =>
                    setEmailSelected({
                      ...email_selected,
                      image_url: e.target.value,
                    })
                  }
                  className="text-h4 "
                ></TextField2T>
                <TextField2T
                  noborder={true}
                  label={"gif_url"}
                  value={email_selected.gif_url}
                  onChange={(e) =>
                    setEmailSelected({
                      ...email_selected,
                      gif_url: e.target.value,
                    })
                  }
                  className="text-h4 "
                ></TextField2T>{" "}
                <TextField2T
                  noborder={true}
                  label={"support_url"}
                  value={email_selected.support_url}
                  onChange={(e) =>
                    setEmailSelected({
                      ...email_selected,
                      support_url: e.target.value,
                    })
                  }
                  className="text-h4 "
                ></TextField2T>
              </div>{" "}
              <div className="flex flex-col max-w-c700 w-full  border-1 rounded-lg ml-4">
                <TextFieldEmail
                  noborder={true}
                  className="h-full max-h-full text-h5 p-3 bg-transparent  rounded-3xl"
                  label={"Contenu"}
                  value={email_selected.body}
                  rows={10}
                  onChange={(e) =>
                    setEmailSelected({
                      ...email_selected,
                      body: e.target.value,
                    })
                  }
                ></TextFieldEmail>

                <div className="text-h3   border-2 border-indigo-600 overflow-auto max-h-c500 ">
                  <div
                    className="prose max-w-none" // optional: Tailwind style for readable HTML
                    dangerouslySetInnerHTML={{ __html: email_selected.body }}
                  />
                </div>
              </div>
            </div>{" "}
            <div className="flex flex-row   gap-4 p-4 border-t-1">
              <WarningButton
                className={"w-fit mr-auto"}
                onClick={() => handleDeleteEmailTemplate()}
              >
                SUPPRIMER
              </WarningButton>{" "}
              <PrimaryButtonHexamails
                className="ml-auto"
                onClick={() => handleGenerateBody()}
              >
                Générer body
                {loadingData && <SmallSpinner></SmallSpinner>}
              </PrimaryButtonHexamails>
              <PrimaryButtonHexamails onClick={() => handleSaveEmailTemplate()}>
                Enregistrer le template{" "}
                {loadingData && <SmallSpinner></SmallSpinner>}
              </PrimaryButtonHexamails>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-1">
            <PrimaryButtonHexamails
              onClick={() => handleCreateNewTemplate(false)}
              startIcon={
                <Icon1 icon_name="plus" width="18px" fill="white"></Icon1>
              }
              className="mb-4"
            >
              Nouveau template {loadingData && <SmallSpinner></SmallSpinner>}
            </PrimaryButtonHexamails>{" "}
            <PrimaryButtonHexamails
              onClick={() => handleCreateNewTemplate(true)}
              startIcon={
                <Icon1 icon_name="plus" width="18px" fill="white"></Icon1>
              }
              className="mb-4"
            >
              Nouveau trigger {loadingData && <SmallSpinner></SmallSpinner>}
            </PrimaryButtonHexamails>
            {email_templates
              .sort(
                (
                  a,
                  b // use .object to sort alphabetically
                ) =>
                  a.object && b.object ? a.object.localeCompare(b.object) : 0
              )
              .map((email, index) => (
                <div key={index}>
                  <BlockEmailTemplate
                    onClick={() => setEmailSelected(email)}
                    title={email.object}
                    number_1={email.send_count || 0}
                    number_2={
                      (email.click_count || 0 / (email.send_count || 1)) * 100
                    }
                    icon="email"
                    sufix="%"
                  />
                </div>
              ))}
          </div>
        )}
      </div>
    </>
  );
}

export const generateDynamicEmailTemplateHtmlFromBaseHtml = (params) => {
  let base = params.trigger ? email_base_trigger : email_base;
  let res_html = base.replaceAll("{{header_text}}", params.header_text || "");
  res_html = res_html.replaceAll("{{body_title}}", params.body_title || "");
  res_html = res_html.replaceAll(
    "{{body_content_1}}",
    params.body_content_1 || ""
  );
  res_html = res_html.replaceAll(
    "{{body_content_2}}",
    params.body_content_2 || ""
  );
  res_html = res_html.replaceAll(
    "{{web_button_label}}",
    params.web_button_label || ""
  );
  res_html = res_html.replaceAll(
    "{{mobile_button_label}}",
    params.mobile_button_label || ""
  );
  // res_html = res_html.replaceAll(
  //   "{{web_button_url}}",
  //   params.web_button_url || ""
  // );
  // res_html = res_html.replaceAll(
  //   "{{mobile_button_url}}",
  //   params.mobile_button_url || ""
  // );
  res_html = res_html.replaceAll("{{support_url}}", params.support_url || "");

  res_html = res_html.replaceAll("{{image_url}}", params.image_url || "");
  res_html = res_html.replaceAll("{{gif_url}}", params.gif_url || "");
  return res_html;
};
